// extracted by mini-css-extract-plugin
export var searchHeader = "_3c-0";
export var searchHeaderDark = "_3c-1";